import { ca } from '@cian/analytics';

export function trackingShowOfferPopup() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'NotActualOfferPopup',
    action: 'Show',
    label: '',
  });
}

export function trackingConfirmActualOfferPopup(id: number) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'NotActualOfferPopup',
    action: 'Click',
    label: 'Yes',
    products: [
      {
        id,
      },
    ],
  });
}

export function trackingConfirmNotActualOfferPopup(id: number) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'NotActualOfferPopup',
    action: 'Click',
    label: 'No',
    products: [
      {
        id,
      },
    ],
  });
}
